import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    _setup.isMobile ? _setup.CoreBottomSheet : _setup.CoreDialog,
    _vm._b(
      {
        tag: "component",
        attrs: { title: "Как работает клубная цена" },
        scopedSlots: _vm._u(
          [
            !_setup.isMobile
              ? {
                  key: "prependBtn",
                  fn: function ({ btnProps }) {
                    return [
                      _c(
                        VBtn,
                        _vm._b(
                          {
                            on: {
                              click: function ($event) {
                                _setup.isOpened = false
                              },
                            },
                          },
                          "v-btn",
                          btnProps,
                          false
                        ),
                        [
                          _c("span", {
                            staticClass: "ui-icon-close-not-a-circle",
                          }),
                        ]
                      ),
                    ]
                  },
                }
              : null,
            {
              key: "actions",
              fn: function () {
                return [
                  _c(
                    VBtn,
                    {
                      staticClass:
                        "bg-primary branding-btn branding-btn--background",
                      attrs: {
                        "data-qa": "modal-actions-btn-close",
                        color: "primary",
                        block: "",
                        text: "",
                      },
                      on: {
                        click: function ($event) {
                          _setup.isOpened = false
                        },
                      },
                    },
                    [_vm._v("\n      Хорошо\n    ")]
                  ),
                ]
              },
              proxy: true,
            },
          ],
          null,
          true
        ),
        model: {
          value: _setup.isOpened,
          callback: function ($$v) {
            _setup.isOpened = $$v
          },
          expression: "isOpened",
        },
      },
      "component",
      _setup.isMobile
        ? {}
        : {
            size: "lg",
            divider: true,
          },
      false
    ),
    [
      _vm._v(" "),
      _setup.clubOfferData.cardDateEnd
        ? _c("div", { staticClass: "text-secondary--text text-body-1 mb-6" }, [
            _vm._v(
              "\n    Вы в клубе до " +
                _vm._s(_setup.clubOfferData.cardDateEnd) +
                " 👑\n  "
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(_setup.StepsToFollow, { staticClass: "mb-4" }),
      _vm._v(" "),
      _c(_setup.ClubInfo, {
        staticClass: "mb-5",
        scopedSlots: _vm._u([
          {
            key: "activator",
            fn: function ({ on }) {
              return [
                _c(
                  "span",
                  _vm._g(
                    {
                      staticClass:
                        "text-body-1 primary--text link-decoration-none cursor-pointer",
                    },
                    on
                  ),
                  [_vm._v("\n        Подробнее о клубе\n      ")]
                ),
              ]
            },
          },
        ]),
      }),
      _vm._v(" "),
      _c("div", { staticClass: "price-details" }, [
        _c(
          "div",
          { staticClass: "price-details__inner pt-6 px-5 pb-5" },
          [
            _c(_setup.ClubPriceDetails, {
              attrs: {
                "full-price": _setup.fullPrice,
                "club-offer-data": _setup.clubOfferData,
                "total-price": _setup.clubOfferData.totalPrice,
                "card-price": _setup.clubOfferData.cardPrice,
                "lpu-price": _setup.clubOfferData.lpuPrice,
                "option-price": _setup.clubOfferData.couponPrice,
                "is-no-card": !_setup.clubOfferData.cardDateEnd,
              },
            }),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }